// The shell's shortcuts sheet (src/app/Shortcuts.tsx) as the aligner shows it: its line on the
// other platform and, after the menus' chords, the grid's keys and the edit box's.

import { ShortcutsSheet } from '../../app/Shortcuts.tsx'
import type { Platform } from '../../core/bindings.ts'

/// The shortcuts sheet's line on the other platform: Join and the moves at a cell's upper boundary
/// take other keys there.
export const PLATFORM_NOTE = (platform: Platform) =>
  platform === 'mac' ? 'On Windows and Linux, Cmd is Ctrl and Option is Alt, except for Join and the moves at a cell’s upper boundary.' : 'On a Mac, Ctrl is Cmd and Alt is Option, except for Join and the moves at a cell’s upper boundary.'

/// The sheet's last sections: the grid's keys and the edit box's, which no command holds.
export const SHEET_SECTIONS = (
  <>
    <section className="task">
      <h3>In the grid</h3>
      <table><tbody>
        <tr><td>Move between cells</td><td><kbd>Up</kbd> <kbd>Down</kbd> <kbd>Left</kbd> <kbd>Right</kbd></td></tr>
        <tr><td>Ten rows, the first row, the last row</td><td><kbd>PageUp</kbd> <kbd>PageDown</kbd> <kbd>Home</kbd> <kbd>End</kbd></td></tr>
        <tr><td>Select a run of cells in the column, for Move, Join and Pinpoint Align</td><td><kbd>Shift</kbd> with <kbd>Up</kbd> <kbd>Down</kbd> or a click</td></tr>
        <tr><td>The other column</td><td><kbd>Tab</kbd></td></tr>
        <tr><td>Put a caret in the cell, or finish Pinpoint Align</td><td><kbd>Enter</kbd></td></tr>
        <tr><td>Take the caret out, cancel Pinpoint Align, end a selection, or leave the grid so Tab moves through the page</td><td><kbd>Esc</kbd></td></tr>
      </tbody></table>
    </section>
    <section className="task">
      <h3>While editing a cell’s text</h3>
      <table><tbody>
        <tr><td>Keep the change</td><td><kbd>Enter</kbd></td></tr>
        <tr><td>A new paragraph</td><td><kbd>Shift+Enter</kbd></td></tr>
        <tr><td>Cancel</td><td><kbd>Esc</kbd></td></tr>
      </tbody></table>
    </section>
  </>
)

export function AlignShortcuts() {
  return <ShortcutsSheet platformNote={PLATFORM_NOTE} sections={SHEET_SECTIONS} />
}
